import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { Box, Typography, Stack } from '@mui/material';
import { API_URL } from '../../../../links/API_LINKS';
import QuestionFormB2C from './QuestionFormB2C';
import { useQueryClient } from 'react-query';

const CreateNewQuestion = ({ setValue }) => {
  const queryClient = useQueryClient();

  const formikRef = useRef();
  const [serverResponse, setServerResponse] = useState();

  return (
    <div>
      <Box>
        <Typography variant='h6'>Add a new Question</Typography> <br />
      </Box>
      <div>
        <Formik
          enableReinitialize={true}
          innerRef={formikRef}
          initialValues={{
            question: '',
            type: 'B2C DOMAIN',
            domain: '',
            options: [
              {
                option: '',
                value: 0,
              },
            ],
            maxSelect: 1,
            skill: null,
            image: [],
          }}
          validationSchema={Yup.object({
            question: Yup.string().required('Please enter a Question'),
            domain: Yup.string().when('type', {
              is: 'B2C DOMAIN',
              then: Yup.string().required('Please select a Domain.'),
            }),
            skill: Yup.string()
              .when('type', {
                is: 'B2C DOMAIN',
                then: Yup.string().required('Please select a skill.'),
              })
              .nullable(),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const updatedData = { ...values };
            console.log(values);
            setServerResponse('');
            axios({
              method: 'POST',
              url: API_URL + '/question',
              data: updatedData,
            })
              .then(function (response) {
                queryClient.invalidateQueries('fetchQuestionB2c');
                setServerResponse('Question added successfully');
                setSubmitting(false);
                response.data.status === 'success' && resetForm();
              })
              .catch(function (response) {
                setServerResponse('Error! Could not process your request.');
                setSubmitting(false);
              });
          }}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <QuestionFormB2C values={values} setFieldValue={setFieldValue} />
              <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                spacing={3}
                mt={2}
              >
                <LoadingButton
                  type='submit'
                  variant='contained'
                  loading={isSubmitting}
                >
                  Add Question
                </LoadingButton>
              </Stack>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  p: 1,
                  m: 1,
                }}
              >
                {serverResponse && <Typography>{serverResponse}</Typography>}
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateNewQuestion;
